module.exports = __webpack_public_path__ + "img/appicon.f2d4ba56.png";